import { useEffect, useState } from "react"
import { Breadcrumb, Button, FloatingLabel, Form } from "react-bootstrap";
import LoadingComponent from "../../widgets/LoadingComponent";
import { FaSearch } from "react-icons/fa";
import { getData, postData } from "../../api/ApiRest";
import AsyncSelect from 'react-select/async';
import { formatDateddMMyyyyhhmm } from "../../widgets/DateTime";
import { useInfoUser } from "../../helper/authHelper";

function Auditoria() {
    const [dataBuscar, setDataBuscar] = useState({
        FechaIni: new Date().toISOString().split("T")[0], FechaFin: new Date().toISOString().split("T")[0], Empresa: '', Accion: '',
        Modulo: '', Seccion: ''
    });

    const { Admin } = useInfoUser();

    const [auditoria, setAuditoria] = useState([]);
    const [loading, setLoading] = useState(false);

    const companieSearchSelect2 = async (Param) => {
        return await getData('api/Configuracion/Company/Select2Company',
            { param: Param }, false).then(response => {
                return response.companies;
            }, error => {
                return [];
            })
    }

    ///Función para buscar la auditoría con parametros
    const buscarAuditoria = (event) => {
        event.preventDefault();
        setLoading(true);

        if (dataBuscar.Accion === '')
            dataBuscar.Accion = "null";

        if (dataBuscar.Empresa === '')
            dataBuscar.Empresa = "null";

        if (dataBuscar.Seccion === '')
            dataBuscar.Seccion = "";

        if (dataBuscar.Modulo === '')
            dataBuscar.Modulo = "null";

        getData('api/Usuario/buscarAuditoria', {
            FechaIni: dataBuscar.FechaIni,
            FechaFin: dataBuscar.FechaFin,
            Accion: dataBuscar.Accion,
            Empresa: dataBuscar.Empresa,
            Seccion: dataBuscar.Seccion,
            Modulo: dataBuscar.Modulo
        }, false).then(response => {

            setAuditoria(response.auditoria);

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item >Seguridad</Breadcrumb.Item>
            <Breadcrumb.Item active={true}>Auditoria</Breadcrumb.Item>
        </Breadcrumb>

        <Form onSubmit={buscarAuditoria}>
            <div className='row'>
                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Fecha Inicial"
                        className="mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            placeholder="Fecha"
                            value={dataBuscar.FechaIni}
                            onChange={value => setDataBuscar({ ...dataBuscar, FechaIni: value.target.value })}
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId="Fecha"
                        label="Fecha Final"
                        className="mb-3"
                    >
                        <Form.Control
                            size='sm'
                            type="date"
                            autoComplete='off'
                            placeholder="Fecha"
                            value={dataBuscar.FechaFin}
                            onChange={value => setDataBuscar({ ...dataBuscar, FechaFin: value.target.value })}
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-2'>
                    <FloatingLabel
                        controlId='Accion'
                        label="Acción"
                    >
                        <Form.Select
                            size='sm'
                            value={dataBuscar.Accion}
                            onChange={event => {
                                setDataBuscar({
                                    ...dataBuscar,
                                    Accion: event.target.value
                                })
                            }}
                        >
                            <option value="null">TODOS</option>
                            <option value="Crea">Crea</option>
                            <option value="Modifica">Modifica</option>
                            <option value="Elimina">Elimina</option>
                        </Form.Select>
                    </FloatingLabel>
                </div>

                {Admin === 'true' ? <div className='col-md-2'>
                    <FloatingLabel
                        controlId='Modulo'
                        label="Modulo"
                    >
                        <Form.Select
                            size='sm'
                            value={dataBuscar.Modulo}
                            onChange={event => {
                                setDataBuscar({
                                    ...dataBuscar,
                                    Modulo: event.target.value
                                })
                            }}
                        >
                            <option value="null">TODOS</option>
                            <option value="Empresa">Empresa</option>
                            <option value="Seguridad">Seguridad</option>
                            <option value="Administracion">Administración</option>
                        </Form.Select>
                    </FloatingLabel>
                </div> : null}

                <div className="col-md-3">
                    <FloatingLabel controlId="SeccionNewInput" label="Sección">
                        <Form.Control
                            as="input"
                            type='text'
                            placeholder="Sección"
                            rows={1}
                            autoComplete='off'
                            value={dataBuscar.Seccion}
                            onChange={event => setDataBuscar({ ...dataBuscar, Seccion: event.target.value })}
                        />
                    </FloatingLabel>
                </div>

                <div className='col-md-1'>
                    <Button variant='primary' type='submit'>
                        <FaSearch size={'1rem'} />
                    </Button>
                </div>

            </div>
            {Admin === "true" ? <div className="row">
                <div className='col-md-5' style={{ marginBottom: 15 }}>
                    <label>Empresa</label>
                    <AsyncSelect cacheOptions defaultOptions
                        menuPosition='fixed'
                        noOptionsMessage={() => 'Escriba para iniciar la busqueda'}
                        placeholder="Empresa"
                        isClearable={true}
                        loadOptions={companieSearchSelect2}
                        onChange={value => {

                            if (value === null)
                                setDataBuscar({ ...dataBuscar, Empresa: '' })
                            else
                                setDataBuscar({ ...dataBuscar, Empresa: value.value })
                        }}
                    />
                </div>
            </div> : null}

        </Form>

        {<LoadingComponent Loading={loading} />}
        <div className='table-responsive mt-2'>
            <table className='table table-sm table-bordered table-hover'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>
                            Fecha
                        </th>
                        <th>
                            Login
                        </th>
                        <th>
                            Empresa
                        </th>
                        <th>
                            Modulo
                        </th>
                        <th>
                            Sección
                        </th>
                        <th>
                            Acción
                        </th>
                        <th>
                            Cambios
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {auditoria.map((item, index) => (
                        <tr key={item.auditoriaid}>
                            <td>
                                {index + 1}
                            </td>
                            <td className='text-center' style={{ fontSize: 14 }}>
                                {formatDateddMMyyyyhhmm(item.fechahora)}
                            </td>
                            <td className='text-center' style={{ fontSize: 14 }}>
                                {item.login}
                            </td>
                            <td className='text-center' style={{ fontSize: 14 }}>
                                {item.empresa}
                            </td>
                            <td className='text-center' style={{ fontSize: 14 }}>
                                {item.modulo}
                            </td>
                            <td className='text-center' style={{ fontSize: 14 }}>
                                {item.seccion}
                            </td>
                            <td className='text-center' style={{ fontSize: 14 }}>
                                {item.accion}
                            </td>
                            <td className='text-center' style={{ fontSize: 14 }}>
                                {item.cambios}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
}

export default Auditoria;